import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import { prepareWebUpdates } from './lib/app-updates'

const mount = () => createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
if (import.meta.env.PROD) void prepareWebUpdates().then(ready => { if (ready) mount() })
else mount()
